module.exports = __webpack_public_path__ + "img/transport_pic05.559494a0.png";